import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	coreInvitesTitleByline: {
		id: 'invite-prompt-on-link-insert.common.use-invite-people-modal.core-invites-title-byline',
		defaultMessage: 'to access {title}',
		description: 'title byline in core invites',
	},
	coreInvitesUserPickerByline: {
		id: 'invite-prompt-on-link-insert.common.use-invite-people-modal.core-invites-user-picker-byline',
		defaultMessage: "These people don't have access to {productDisplayName}",
		description: 'user picker byline in core invites',
	},
});
